// Billing utilities for organization mentor management

export const calculateSeatPricing = (basePlan, seatCount) => {
  const pricing = {
    'mentor-basic': {
      1: 999,
      2: 899,
      3: 799,
      4: 749,
      5: 699,
      6: 649,
      7: 599,
      8: 549,
      9: 499,
      10: 449
    },
    'mentor-pro': {
      1: 1299,
      2: 1199,
      3: 1099,
      4: 1049,
      5: 999,
      6: 949,
      7: 899,
      8: 849,
      9: 799,
      10: 749
    },
    'mentor-premium': {
      1: 1599,
      2: 1499,
      3: 1399,
      4: 1349,
      5: 1299,
      6: 1249,
      7: 1199,
      8: 1149,
      9: 1099,
      10: 1049
    }
  };

  const planPricing = pricing[basePlan] || pricing['mentor-basic'];
  
  // For seat counts beyond 10, use the 10-seat price
  const effectiveSeatCount = Math.min(seatCount, 10);
  const pricePerSeat = planPricing[effectiveSeatCount] || planPricing[10];
  
  return {
    pricePerSeat,
    totalPrice: pricePerSeat * seatCount,
    seatCount,
    planType: basePlan
  };
};

export const calculateProratedAmount = (currentPlan, newSeatCount, daysRemaining) => {
  const currentPrice = currentPlan.totalMonthlyPrice;
  const newPricing = calculateSeatPricing(currentPlan.planType, newSeatCount);
  const newPrice = newPricing.totalPrice;
  
  const priceDifference = newPrice - currentPrice;
  const proratedAmount = (priceDifference * daysRemaining) / 30; // Assuming 30-day cycles
  
  return {
    currentPrice,
    newPrice,
    priceDifference,
    proratedAmount: Math.round(proratedAmount * 100) / 100, // Round to 2 decimal places
    daysRemaining
  };
};

export const getBillingScenarios = (currentPlan, requestedSeats) => {
  const scenarios = [];
  
  // Always show "Add Mentor to Current Plan" option when adding new mentors
  if (requestedSeats > 0) {
    // Calculate the total seats after adding new mentors
    const totalSeatsAfter = currentPlan.totalSeats + requestedSeats;
    const prorated = calculateProratedAmount(currentPlan, totalSeatsAfter, currentPlan.daysRemaining);
    
    scenarios.push({
      type: 'add_seats',
      title: 'Add Mentor to Current Plan',
      description: `Add ${requestedSeats} mentor seat${requestedSeats > 1 ? 's' : ''} to your existing ${currentPlan.planType.replace('mentor-', '').toUpperCase()} plan`,
      immediateCharge: prorated.proratedAmount,
      nextBillingCycle: prorated.newPrice,
      benefits: [
        'Keep your current plan features',
        'Immediate access to new mentor seats',
        'Prorated billing for remaining cycle'
      ]
    });
  }
  
  return scenarios;
};

export const formatBillingSummary = (scenario, currentPlan) => {
  return {
    title: scenario.title,
    description: scenario.description,
    pricing: {
      immediate: scenario.immediateCharge > 0 ? `$${scenario.immediateCharge}` : 'No immediate charge',
      nextCycle: `$${scenario.nextBillingCycle}/month`,
      savings: scenario.savings || null
    },
    benefits: scenario.benefits,
    action: scenario.type === 'add_seats' ? 'Add Seats' : 'Upgrade Plan'
  };
};
